/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import PowerUp from '../mathLines/PowerUp';
import Shooter from '../mathLines/Shooter';
import Track from '../mathLines/Track';
import TrackBalls from '../mathLines/TrackBalls';
import TrackPoints from '../mathLines/TrackPoints';
import SoundAssetKeys from '../SoundAssetKeys';

export default class GameLevel extends Phaser.GameObjects.Container {
  constructor(scene, data) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.bonusSound = ABCyaPhaser.Audio.createSound(this.scene);
    this.ballSpeed = 15;
    this.bonusCounter = 0;

    this.levelData = data;
    this.trackBg = ABCyaPhaser.Images.addImage(0, 0, `track-${this.levelData.trackID}-bg`, this).setOrigin(0, 0);

    this.firedBalls = [];
    this.tracks = [];
    this.bonusVals = [];

    this.factors = [];

    for (let i = 1; i < gameData.addNum + 1; i++) {
      if (gameData.addNum % i === 0) {
        this.factors.push(i);
      }
    }
  }

  setUpLevel() {
    this.setUpTrack();
  };

  setUpTrack() {
    const track = new Track(this.scene, this.levelData.pathSegments);
    this.tracks.push(track);
    track.layers = [];

    let track2;
    if (this.levelData.trackID === 3) {
      track2 = new Track(this.scene, this.levelData.pathSegments2);
      this.tracks.push(track2);
      track2.layers = [];
    }

    if (this.levelData.layers) {
      const holders = [];
      const pos = [{ x: 0, y: 102 },{ x: 55, y: 60 },{ x: 607, y: 60 },{ x: 240, y: 119 }];

      while (holders.length < this.levelData.layers.length) {
        holders.push(null);
      }

      for (let l = 0; l < this.levelData.layers.length; l++) {
        const container = this.scene.add.container();
        const layerPiece = ABCyaPhaser.Images.addImage(0, 0, `piece${l}`, container).setOrigin(0, 0);

        if (gameData.level === 2) layerPiece.setPosition(pos[l].x, pos[l].y);

        const data = this.levelData.layers[l];
        const d = data.depthOrder;
        container.pieceName = `piece${l}`;
        holders[d] = container;
        const layerObj = { layerContainer: container, end: data.end };
        track.layers.push(layerObj);
      }

      // swap holders with layer pieces for correct order;
      for (let r = 0; r < holders.length; r++) {
        this.add(holders[r]);
      }
    }
    else {
      if (this.levelData.trackID === 3) {
        const track1Container = this.scene.add.container();

        const track1Bg = ABCyaPhaser.Images.addImage(0, 0, 'track-3b', track1Container).setOrigin(0, 0);

        this.add(track1Container);
        track.layers = [{ layerContainer: track1Container,end: 'total' }];

        const track2Container = this.scene.add.container();

        const track2Bg = ABCyaPhaser.Images.addImage(0, 0, 'track-3a', track1Container).setOrigin(0, 0);
        this.add(track2Container);
        track2.layers = [{ layerContainer: track2Container,end: 'total' }];
      }
      else {
        const wholeContainer = this.scene.add.container();
        this.add(wholeContainer);
        track.layers = [{ layerContainer: wholeContainer, end: 'total' }];
      }
    }

    this.setUpBalls();
  };

  setUpBalls() {
    for (let i = 0; i < this.tracks.length; i++) {
      const track = this.tracks[i];
      const trackBalls = new TrackBalls(this.scene, track, track.layers, this.factors);
      trackBalls.on('TRACK_HIT', (shot) => {this.handleTrackHit(shot);});
      trackBalls.on('GET_POINTS', (points, hitX, hitY) => {this.handlePoints(points, hitX, hitY);});
      trackBalls.on('TRACK_END', (completed) => {this.handleTrackComplete(trackBalls, completed);});
      track.balls = trackBalls;
    }

    this.shooter = new Shooter(this.scene);
    this.shooter.x = this.trackBg.getBounds().width / 2 - 10;
    this.shooter.y = this.trackBg.getBounds().height / 2 - 10;
    this.add(this.shooter);

    const firstShotNum = this.factors[Phaser.Math.Between(0,this.factors.length - 1)];
    this.shooter.readyNextShot(firstShotNum,Phaser.Math.Between(1,8));

    this.isBonusShowing = false;

    this.bonusCounter = 60;

    this.startLevel();
  };

  startLevel() {
    this.pressPts = [];
    this.scene.input.on('pointerdown', (e) => {this.handlePressDown(e);});
    this.scene.input.on('pointermove', (e) => {this.handlePressMove(e);});
    this.scene.input.on('pointerup', (e) => {this.handlePressUp(e);});

    this.isReady = true;
  };

  handlePressDown(e) {
    if (this.isReady === true) {
      const pressObj = { id: e.id, pX: e.x, pY: e.y };

      if (e.id === -1) {
        this.pressPts = [pressObj];
      }
      else {
        this.pressPts.push(pressObj);
      }

      if (this.pressPts.length === 1) this.shooter.pointAt((e.x - this.x) / this.scaleX, (e.y - this.y) / this.scaleY);
    }
  };

  handlePressMove(e) {
    if (this.isReady === true) {
      if (this.pressPts.length > 0) {
        if (e.id === this.pressPts[0].id || e.id === -1) {
          this.shooter.pointAt((e.x - this.x) / this.scaleX,(e.y - this.y) / this.scaleY);
        }
      }
    }
  };

  handlePressUp(e) {
    if (this.isReady === true) {
      let triggerFinger = false;
      if (e.id === -1) {
        this.pressPts = [];
        triggerFinger = true;
      }
      else {
        // find pressPt with id
        const len = this.pressPts.length;
        for (let i = 0; i < len; i++) {
          if (this.pressPts[i].id === e.id) {
            this.pressPts.splice(i,1);
            if (i === 0) triggerFinger = true;
            break;
          }
        }
      }

      if (triggerFinger) {
        const shot = this.shooter.shoot();
        if (shot !== null) {
          this.handleBallFired(shot);
        }
      }

      if (this.pressPts.length > 0) {
        this.shooter.pointAt((this.pressPts[0].pX - this.x) / this.scaleX,(this.pressPts[0].pY - this.y) / this.scaleY);
      }
    }
  };

  handleBallFired(shotInfo) {
    if (!shotInfo) return;

    const newShot = shotInfo.ball;
    newShot.angle = 0;

    // trajectory from angle
    const shotAngle = shotInfo.shotAngle * Math.PI / 180;
    newShot.tx = Math.cos(shotAngle);
    newShot.ty = Math.sin(shotAngle);

    this.firedBalls.push(newShot);
    if (this.bonusVals.length === 0) {
      const rTrack = this.tracks[Phaser.Math.Between(0,this.tracks.length - 1)];
      let shotNum = this.factors[Phaser.Math.Between(0,this.factors.length - 1)];
      if (rTrack.balls.balls.length === 0) {
        shotNum = this.factors[Phaser.Math.Between(0,this.factors.length - 1)];
      }
      else {
        let randomBallNum = rTrack.balls.balls[Phaser.Math.Between(0,rTrack.balls.balls.length - 1)].numValue;
        if (randomBallNum === 0) randomBallNum = this.factors[Phaser.Math.Between(0,this.factors.length - 1)];
        shotNum = gameData.addNum / randomBallNum;
      }

      this.shooter.readyNextShot(shotNum,Phaser.Math.Between(1,8));
    }
    else {
      const bonusVal = this.bonusVals[Phaser.Math.Between(0,1)];
      this.shooter.readyNextShot(bonusVal.val,bonusVal.colorId);
    }
  };

  updateLevel() {
    if (this.isReady === true) {
      if (this.isBonusTriggered === true) {
        this.bonusCounter--;
        if (this.bonusCounter <= 0) {
          this.clearBonus();
        }
      }
      else {
        if (this.isBonusShowing === false) {
          this.bonusCounter--;
          if (this.bonusCounter <= 0) {
            this.addPowerUp();
          }
        }
        else {
          this.bonusCounter++;
          if (this.bonusCounter >= 400) {
            this.clearPowerUp();
          }
        }
      }

      if (this.shooter) {
        if (this.pressPts.length > 0) {

        }
        else {
          if (gameData.isMobile === false) {
            this.shooter.pointAt(gameData.stage.mouseX - this.x,gameData.stage.mouseY - this.y);
          }
        }
      }

      if (this.tracks.length > 0) {
        for (let i = 0; i < this.tracks.length; i ++) {
          this.tracks[i].balls.moveBalls();
        }
      }

      let b = this.firedBalls.length;
      while (b--) {
        const ball = this.firedBalls[b];
        ball.x += this.ballSpeed * ball.tx;
        ball.y += this.ballSpeed * ball.ty;

        if (ball.x < -(gameData.BALL_SIZE / 2 + this.x) / this.scaleX || ball.x > (gameData.screen_width + (gameData.BALL_SIZE / 2)) / this.scaleX || ball.y < -(gameData.BALL_SIZE / 2) / this.scaleY || ball.y > (gameData.screen_height + (gameData.BALL_SIZE / 2)) / this.scaleY) {
          this.firedBalls.splice(b,1);
          ball.destroy();
          continue;
        }

        if (ball.isHit === false) {
          let t = this.tracks.length;
          while (t--) {
            this.checkShotCollision(this.tracks[t], ball);
          }

          if (this.powerUp && this.powerUp.isHit === false) {
            // console.log(ball.x);
            const dist = Phaser.Math.Distance.Between(this.powerUp.x, this.powerUp.y, ball.x, ball.y);
            const threshold = this.powerUp.displayClip.getBounds().width / 2;

            if (dist <= threshold) {
              // remove power up
              this.hitPowerUp();
              this.firedBalls.splice(b,1);

              ABCyaPhaser.Tweens.addTween(ball, 800, { alpha: 0,scaleX: 1.5,scaleY: 1.5 }, Phaser.Math.Easing.Back.Out, () => {
                ball.destroy();
              });
            }
          }
        }
      }
    }
  };

  checkShotCollision(track,ball) {
    track.balls.checkHit(ball);
  };

  handleTrackHit(e) {
    this.firedBalls.splice(this.firedBalls.indexOf(e), 1);
  };

  addPowerUp() {
    this.isBonusShowing = true;
    this.bonusCounter = 0;

    // add power up to random corner
    const corners = ['top','left','right','bottom-left','bottom-right'];
    const rCorner = corners[Phaser.Math.Between(0,corners.length - 1)];
    this.powerUp = new PowerUp(this.scene, rCorner, this.parentContainer);
    this.parentContainer.add(this.powerUp);
  };

  clearPowerUp() {
    this.isBonusShowing = false;
    this.bonusVals = [];
    this.bonusCounter = Phaser.Math.Between(600,1000);
    if (this.powerUp !== null) {
      this.powerUp.removePowerUp();
      this.powerUp = null;
    }
  };

  hitPowerUp() {
    this.powerUp.hit();
    this.powerUp = null;
    this.isBonusShowing = false;
    this.isBonusTriggered = true;
    const randomColor1 = Phaser.Math.Between(1,4);
    const randomColor2 = Phaser.Math.Between(5,8);
    let num1 = this.factors[Phaser.Math.Between(0,this.factors.length - 1)];
    let num2 = gameData.addNum / num1;
    if (num1 === num2) {
      // hacky fix for 36, only num that can have the both numbers the same for bonus
      num1 = 3;
      num2 = 12;
    }
    this.bonusVals = [{ val: num1,colorId: randomColor1 },{ val: num2,colorId: randomColor2 }];

    let t = this.tracks.length;
    while (t--) {
      this.tracks[t].balls.setBonusValues(this.bonusVals);
    }

    this.shooter.changeShots(this.bonusVals[0].val,this.bonusVals[0].colorId,this.bonusVals[1].val,this.bonusVals[1].colorId);
    this.bonusCounter = 600;

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._powerup, this.scene);
  };

  clearBonus() {
    this.isBonusTriggered = false;
    this.bonusVals = [];
    let t = this.tracks.length;
    while (t--) {
      this.tracks[t].balls.setBonusValues(this.bonusVals);
    }

    this.clearPowerUp();
  };

  handlePoints(points, hitX, hitY) {
    gameData.score += points;
    const p = new TrackPoints(this.scene, points);
    p.x = hitX;
    p.y = hitY;
    this.add(p);
  };

  handleTrackComplete(balls, e) {
    balls.off('TRACK_HIT');
    balls.off('GET_POINTS');
    balls.off('TRACK_END');

    let proceed = true;
    if (e === false) {
      proceed = true;
    }
    else {
      balls.isComplete = true;

      for (let i = 0; i < this.tracks.length; i++) {
        if (this.tracks[i].balls.isComplete === false) proceed = false;
      }
    }

    if (proceed === true) {
      this.isReady = false;
      if (this.powerUp) {
        this.powerUp.cleanUp();
        this.powerUp = null;
      }
      this.scene.input.off('pointerdown');
      this.scene.input.off('pointerup');
      this.scene.input.off('pointermove');

      this.emit('LEVEL_END', e);
    }
  };

  showBonus() {
    for (let i = 0; i < this.tracks.length; i++) {
      const track = this.tracks[i];
      const distanceLeft = track.totalLineLength - track.balls.startDistance;
      const spaces = Math.round(distanceLeft / gameData.BALL_SIZE);
      this.bonusCounter = spaces;
      this.inverseCounter = gameData.level === 3 ? (spaces * -1) + 1 : 0;
      const delay = 50;
      const stars = [];
      for (let s = 0; s < spaces; s++) {
        const star = ABCyaPhaser.Images.addImage(0, 0, 'star', this);
        const starDist = track.balls.startDistance + (s * gameData.BALL_SIZE);
        const starLocData = track.getEvenTrackPoint(starDist);
        star.x = starLocData.curvePt.x;
        star.y = starLocData.curvePt.y;
        star.scaleX = 0;
        star.scaleY = 0;
        star.alpha = 0;
        stars.push(star);

        ABCyaPhaser.Tweens.addTween(star, 300, { delay: delay * s, alpha: 1,scaleX: 1.5,scaleY: 1.5 }, Phaser.Math.Easing.Quadratic.In, () => {
          ABCyaPhaser.Tweens.addTween(star, 300, { alpha: 0,scaleX: 0,scaleY: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
            this.countBonus();
          });
        });
      }
    }

    this.tallying = true;

    // loop bonus sound
    ABCyaPhaser.Audio.playSound(SoundAssetKeys._score_tally_loop, this.bonusSound);
    this.bonusSound.once('complete', () => {this.loopBonusSound();});
  };

  loopBonusSound() {
    if (this.tallying === true) {
      ABCyaPhaser.Audio.playSound(SoundAssetKeys._score_tally_loop, this.bonusSound);
      this.bonusSound.once('complete', () => {this.loopBonusSound();});
    }
    else {
      this.bonusSound.destroy();
      this.bonusSound = null;
    }
  };

  countBonus() {
    gameData.score += 1;
    this.bonusCounter--;

    if (this.bonusCounter <= this.inverseCounter) {
      this.tallying = false;

      if (this.bonusSound) {
        this.bonusSound.destroy();
        this.bonusSound = null;
      }

      this.finishBonus();
    }
  };

  finishBonus() {
    console.log('win sounds');
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._win_level, this.scene);

    this.emit('BONUS_COMPLETE');
  };

  cleanUp() {
    // remove track listeners
    if (this.powerUp) this.powerUp.cleanUp();

    while (this.tracks.length > 0) {
      const track = this.tracks.shift();
    }
  };
}